import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';
import Mustache from 'mustache';

export default class ThemeMiniCart {

	constructor(dom, cartService) {
		this.NAME = `ThemeMiniCart`;
		this.dom = dom;

		this.domActiveClass = `theme-mini-cart--active`;

		this.cartService = cartService;

		this.htmlNoScrollClass = `no-scroll`;

		this.closeCartTimer;

		this.closeButtonDom = this.dom.querySelector(`[data-theme-mini-cart-close]`);
		this.lineItemsDom = this.dom.querySelector(`[data-theme-mini-cart-line-items]`);
		this.lineItemsDomDisabledClass = `theme-mini-cart__line-items--disabled`;

		this.lineItemEmptyStateTemplate = this.dom.querySelector(`[data-theme-mini-cart-line-item-empty-state-template]`).innerHTML;
		this.lineItemTemplate = this.dom.querySelector(`[data-theme-mini-cart-line-item-template]`).innerHTML;

		this.totalQuantityDom = this.dom.querySelector(`[data-theme-mini-cart-total-quantity]`);
	}

	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		// Listen for events to open the mini cart
		document.addEventListener(`mini-cart.open`, function (event) {
			self.openCart();
		});

		// Listen for events to close the mini cart
		document.addEventListener(`mini-cart.close`, function (event) {
			self.closeCart();
		});

		this.closeButtonDom.addEventListener('click', (e) => {
			e.preventDefault();
			self.closeCart();
		});

		// Listen for cart.added
		this.cartService.on(`cart.added`, () => {
			self.openCart();
			clearTimeout(this.closeCartTimer);
			self.closeCartTimer = setTimeout(self.closeCart.bind(self), 4000);
		});

		// Listen for cart.updating
		this.cartService.on(`cart.updating`, () => {
			self.disableInteractions();
		});

		// Listen for cart.updated
		this.cartService.on(`cart.updated`, () => {
			self.updateCartContents();
		});

		this.updateCartContents();
	}

	closeCart() {
		Logger.info(`${this.NAME} > closeCart`);
		this.dom.classList.remove(this.domActiveClass);
		document.removeEventListener('click', this.boundDetectOutsideClicksFn); document.documentElement.classList.remove(this.htmlNoScrollClass);
		document.body.classList.remove(this.htmlNoScrollClass);
	}

	createEmptyState() {
		Logger.info(`${this.NAME} > createLineItem`);

		const rendered = Mustache.render(this.lineItemEmptyStateTemplate, {});

		// Parse the template into a dom
		const parser = new DOMParser();
		const html = parser.parseFromString(rendered, "text/html");
		const lineItemDom = html.querySelector(`[data-theme-mini-cart-line-item]`);

		return lineItemDom;
	}

	createLineItem(item) {
		Logger.info(`${this.NAME} > createLineItem`);

		const self = this;

		let waitTime = null;
		if (item.metafields?.variant_wait_time) {
			waitTime = item.metafields.variant_wait_time;
		}

		const payload = {
			image: item.image,
			price: (item.final_line_price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
			quantity: item.quantity,
			size: null,
			title: item.product_title,
			stone: null,
			waitTime: waitTime,
			weeksString: waitTime > 1 ? 'weeks' : 'week'
		}

		// Check to see if a Size is set
		if (item.options_with_values) {
			for (const option in item.options_with_values) {
				switch (item.options_with_values[option].name) {
					case 'Size':
						payload.size = item.options_with_values[option].value;
						break;
					case 'Stone':
						payload.stone = item.options_with_values[option].value;
						break;
				}
			}
		}

		// console.log(payload);
		// console.log(this.lineItemTemplate);
		const rendered = Mustache.render(this.lineItemTemplate, payload);

		// Parse the template into a dom
		const parser = new DOMParser();
		const html = parser.parseFromString(rendered, "text/html");
		const lineItemDom = html.querySelector(`[data-theme-mini-cart-line-item]`);

		// Enable the remove button
		const removeButton = lineItemDom.querySelector(`[data-theme-mini-cart-line-item-remove-button]`);
		removeButton?.addEventListener(`click`, e => {
			e.preventDefault();
			self.cartService.change(item.key, {
				quantity: 0
			});
		});

		return lineItemDom;
	}

	disableInteractions() {
		Logger.info(`${this.NAME} > disableInteractions`);
		this.lineItemsDom.classList.add(this.lineItemsDomDisabledClass);
	}

	enableInteractions() {
		Logger.info(`${this.NAME} > enableInteractions`);
		this.lineItemsDom.classList.remove(this.lineItemsDomDisabledClass);
	}

	openCart() {
		Logger.info(`${this.NAME} > openCart`);
		this.dom.classList.add(this.domActiveClass);

		let event = new Event("header.search.close");
		document.dispatchEvent(event);

		event = new Event("header.drawers.close");
		document.dispatchEvent(event);

		event = new Event("header.support.close");
		document.dispatchEvent(event);

		document.documentElement.classList.add(this.htmlNoScrollClass);
		document.body.classList.add(this.htmlNoScrollClass);
	}

	async updateCartContents() {
		Logger.info(`${this.NAME} > updateCartContents`);

		const self = this;

		const cartJson = await this.cartService.get(true);

		console.log(cartJson);

		// Update the header with the total quantity
		this.totalQuantityDom.innerHTML = cartJson.item_count ? ` (${cartJson.item_count})` : ``;

		// Update the line items
		this.lineItemsDom.innerHTML = '';
		if (!cartJson.item_count) {
			const emptyStateDom = self.createEmptyState();
			self.lineItemsDom.appendChild(emptyStateDom);
		} else {

			cartJson.items.forEach((item) => {
				const lineItemDom = self.createLineItem(item);
				self.lineItemsDom.appendChild(lineItemDom);
			});
		}

		this.enableInteractions();
	}
}

// Mixins
Object.assign(ThemeMiniCart.prototype, eventMixin);
